import { Component, Inject, OnInit } from '@angular/core';
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyJsonschema } from '@ngx-formly/core/json-schema';
import { FormGroup } from '@angular/forms';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import {
  CreateOrgAppRequest,
  OrgAppDto, StatusType,
  UpdateOrgAppRequest
} from "../../hopper/octopus/client";
import { OctopusService } from "../../services/octopusService";

@Component({
  selector: 'app-configura-app-octopus',
  templateUrl: './configura-app-octopus.component.html',
  styleUrls: ['./configura-app-octopus.component.scss']
})

export class ConfiguraAppOctopusComponent implements OnInit {
  applicationId: string = undefined;
  applicationName: string = undefined;
  optionsSchema: string = undefined;
  orgIdApp: string = undefined;
  orgApp: OrgAppDto;

  suporte = true;
  carregando = true;
  editavel = false;

  formlyForm: FormGroup;
  options: FormlyFormOptions;
  fields: FormlyFieldConfig[];
  model: any = {};

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private carregandoService: CarregandoService,
    private formlyJsonschema: FormlyJsonschema,
    private notificacaoService: NotificacaoService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ConfiguraAppOctopusComponent>,
    private hopperOctopusGiService: OctopusService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const { applicationId, applicationName, optionsSchema, orgAppId } = data;

    this.applicationId = applicationId;
    this.applicationName = applicationName;
    this.optionsSchema = optionsSchema;
    this.orgIdApp = orgAppId;
    this.editavel = orgAppId != null;
  }

  ngOnInit() {
    if (this.editavel) {
      this.buscaAplicacao();
    }
    else {
      this.orgApp = new OrgAppDto();
      this.orgApp.displayName = this.applicationName;
      this.createForm();
    }
  }

  createForm() {
    this.formlyForm = new FormGroup({});
    this.options = {};

    this.fields = [
      this.formlyJsonschema.toFieldConfig(JSON.parse(this.optionsSchema)),
    ];
  }

  buscaAplicacao() {
    this.carregandoService.mostra('buscaApp');
    this.hopperOctopusGiService.client.hubOrgAppGetEndpoint(this.orgIdApp).subscribe(data => {
      this.orgApp = data.result;
      this.model = JSON.parse(this.orgApp.optionsModel);

      this.carregandoService.esconde('buscaApp');
      this.createForm();
    }, (erro) => {
      this.carregandoService.esconde('buscaApp');
      this.notificacaoService.erro('Não foi possível buscar o aplicativo');
    });
  }

  salvar() {
    this.carregandoService.mostra('SalvaConfigApp');
    const optionsModel = JSON.stringify(this.model);

    if (this.editavel) {
      const data = new UpdateOrgAppRequest({
        displayName: this.orgApp.displayName,
        status: this.orgApp.status,
        optionsModel
      });

      this.hopperOctopusGiService.client.hubOrgAppUpdateEndpoint(this.orgIdApp, data).subscribe(
        () => {
          this.carregandoService.esconde('SalvaConfigApp');
          this.fechar(true);
        }, (erro) => {
          this.carregandoService.esconde('SalvaConfigApp');
          if (erro.status === 201) {
            this.fechar(true);
          } else {
            this.notificacaoService.erro('Não foi possível salvar a configuração do aplicativo.');
          }
        });
    } else {
      const data = new CreateOrgAppRequest({
        applicationId: this.applicationId,
        displayName: this.orgApp.displayName,
        optionsModel
      });

      this.hopperOctopusGiService.client.hubOrgAppCreateEndpoint(data).subscribe(
        () => {
          this.carregandoService.esconde('SalvaConfigApp');
          this.fechar(true);
        }, (erro) => {
          this.carregandoService.esconde('SalvaConfigApp');
          if (erro.status === 201) {
            this.fechar(true);
          } else {
            this.notificacaoService.erro('Não foi possível salvar a configuração do aplicativo.');
          }
        });
    }
  }

  desativar() {
    if (this.orgApp.status === StatusType.Active) {
      this.orgApp.status = StatusType.Inactive;
    } else {
      this.orgApp.status = StatusType.Active;
    }

    this.salvar();
  }

  fechar(result = false) {
    this.dialogRef.close(result);
  }
}
